/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Snap to object</h4>

<p>Make a vertex, edge or face snap to another vertex, edge or face, either of a phi body or from an imported reference model.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('770817971')}"
        loading="lazy"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>N</b>: Snap to target</li>
</ul>`;

export default function SnapToObjectTooltip() {
    return h('div', { innerHTML: body });
}
